import dynamic from 'next/dynamic';

import type { DrupalBlock } from '@commons/types/drupal';

/**
 * Lazy loading the variants to reduce the initial bundle size.
 *
 * This does not work when used in a pagebuilder factory directly, because every items are loaded at once.
 * Doing it in the component itself ensures that the chunks are only loaded when the component is rendered.
 *
 * @see https://nextjs.org/docs/app/building-your-application/optimizing/lazy-loading
 */

const GlobalSearch = dynamic(() => import('./Global'));
const InsightsSearch = dynamic(() => import('./Insights'));

// Enum of the available AlgoliaSearch block variants.

enum ALGOLIA_SEARCH_VARIANT {
  Global = 'global',
  Insights = 'insights',
}

// Type definition for the AlgoliaSearchBlock component properties.

type Props = DrupalBlock<{
  variant: ALGOLIA_SEARCH_VARIANT;
}>;

/**
 * AlgoliaSearch block component.
 *
 * Renders the appropriate variant based on the block configuration.
 */

const AlgoliaSearchBlock = ({ content }: Props) => {
  switch (content.variant) {
    default:
    case ALGOLIA_SEARCH_VARIANT.Global:
      return <GlobalSearch />;
    case ALGOLIA_SEARCH_VARIANT.Insights:
      return <InsightsSearch />;
  }
};

export default AlgoliaSearchBlock;
